const topics = [
  {
    title: "Sound Vibration", standardNumber: "1-PS4-1", slug: "soundvibration",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoundvibration2025video.mp4?alt=media&token=cb99546b-37d4-4f3f-a966-0ce7a9d81ce3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoundvibration2025song.mp3?alt=media&token=db451312-dd9d-4c4c-babe-357802dc1d67",
    lyrics: ["(chorus)",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  
  "(verse)",
  "When you grab your guitar and pluck on the string,",
  "Listen to the sound, it makes you want to sing.",
  "Vibration, vibration, vibration, vibration.",
  "You can speak very soft or speak very loud.",
  "Your vocal cords vibrate producing sound.",
  "Vibration, vibration, vibration, vibration.",
  
  "(chorus)",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      
    ],
  },
  {
    title: "Instruments", standardNumber: "1-PS4-1", slug: "instruments",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Finstruments2025video.mp4?alt=media&token=093de551-f834-49ce-8d4c-d57e59444a8e",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finstruments2025song.mp3?alt=media&token=f1dd67e9-5b49-4fbd-b112-7726a694c558",
    lyrics: ["(Verse)",
  "What do we hear making that sound?",
  "What do we hear making that sound?",
  "It’s the guitar’s vibrating strings,",
  "That makes me want to sing.",
  
  "What do we hear making that sound?",
  "What do we hear making that sound?",
  "It’s the violin’s vibrating strings,",
  "That makes me want to sing.",
  
  "What do we hear making that sound?",
  "What do we hear making that sound?",
  "It’s the flute’s vibrating air,",
  "That’s the sound I love to hear.",
  
  "What do we hear making that sound?",
  "What do we hear making that sound?",
  "It’s the trumpet’s vibrating air,",
  "That’s the sound I love to hear.",
  
  "What do we hear making that sound?",
  "What do we hear making that sound?",
  "It’s the drum’s vibrating head,",
  "Making me shake my head.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      
    ],
  },
  {
    title: "Vibrations All Around", standardNumber: "1-PS4-1", slug: "vibrationsallaround",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fvibrationsallaround2025song.mp3?alt=media&token=dd1d047b-88df-4092-add0-5e055da7b377 ",
    lyrics: ["(Chorus)",
  "Vibrations here, vibrations there,",
  "Sounds are moving through the air!",
  "Our bodies make them, our bodies hear,",
  "Let’s learn how sound appears so clear!",
  
  "(Verse 1)",
  "Our vocal cords vibrate when we speak,",
  "Air makes them move, and sound so sweet.",
  "Stretch them tight, the pitch goes high,",
  "Loosen them up, the pitch drops by!",
  
  "(Chorus)",
  "Vibrations here, vibrations there,",
  "Sounds are moving through the air!",
  "Our bodies make them, our bodies hear,",
  "Let’s learn how sound appears so clear!",
  
  "(Verse 2)",
  "The ear detects vibrations, vibrations around.",
  "The outer ear collects the sound.",
  "Through the canal, the eardrum shakes.",
  "We hear the sound when the tiny bones vibrate!",
  "Vibration in the inner ear is where the magic is done.",
  "The nerve sends signals to the brain for fun.",
  "The brain understands the sound we hear,",
  "It’s vibrations that make it so clear!",
  
  "(Chorus)",
  "Vibrations here, vibrations there,",
  "Sounds are moving through the air!",
  "Our bodies make them, our bodies hear,",
  "Let’s learn how sound appears so clear!",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      
    ],
  },
  {
    title: "Light", standardNumber: "1-PS4-2", slug: "light",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Flight2025video.mp4?alt=media&token=e7758050-0078-4d93-b9be-6d7279f31adb ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flight2025song.mp3?alt=media&token=aa526964-cb68-443b-a1fd-be046cbfeaa0 ",
    lyrics: ["(chorus)",
  "Light helps us see, light helps us know,",
  "where things are and where to go!",
  "In the dark, they disappear,",
  "but with light, they’re bright and clear!",
  "Light helps us see, light helps us know,",
  "where things are and where to go!",
  "In the dark, they disappear,",
  "but with light, they’re bright and clear!",
  
  "(verse)",
  "Light reflects off what we see,",
  "then travels to you and me.",
  "Our eyes catch light, and that’s the key,",
  "to seeing things like a book or tree.",
  "No light? It’s dark, and things are gone,",
  "you might bump into stuff at dawn!",
  "Turn on a lamp or shine the sun,",
  "now you see, and learning’s fun!",
  
  "(chorus)",
  "Light helps us see, light helps us know,",
  "where things are and where to go!",
  "In the dark, they disappear,",
  "but with light, they’re bright and clear!",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      
    ],
  },
  {
    title: "The Sun Brings Light", standardNumber: "1-PS4-2", slug: "thesunbringslight",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthesunbringslight2025video.mp4?alt=media&token=9c5bcfa1-80ab-4aef-9fb0-9283b388ea70 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthesunbringslight2025song.mp3?alt=media&token=03d2d5c9-1da4-4232-9e9e-63e9cbdf3b69 ",
    lyrics: ["(chorus)",
  "The sun brings light, the sun brings heat,",
  "It warms the Earth beneath our feet.",
  "Some light reflects, some light’s absorbed,",
  "It powers the Earth, a life-giving force!",
  
  "(verse)",
  "Light travels far from the sun to here,",
  "It heats the Earth, the air so clear.",
  "The land and water soak it in,",
  "Patterns of warmth help life begin!",
  "Reflecting light bounces back to space,",
  "But the heat we keep is nature’s grace.",
  "Plants grow tall, and oceans glow,",
  "The sun’s bright energy makes it so!",
  
  "(chorus)",
  "The sun brings light, the sun brings heat,",
  "It warms the Earth beneath our feet.",
  "Some light reflects, some light’s absorbed,",
  "It powers the Earth, a life-giving force!",
  "The sun brings light, the sun brings light,",
  "It warms the Earth beneath our feet.",
  "Some light reflects, some light’s absorbed,",
  "It powers the Earth, a life-giving force!",
  
  "(verse)",
  "Absorb the light, feel the heat,",
  "The sun makes life a perfect feat.",
  "Patterns of warmth, day by day,",
  "The sun keeps life going in every way!",
  "The sun is a star, a shining light,",
  "It keeps us warm through day and night.",
  "Reflect, absorb, the patterns we see,",
  "The sun is the key to life’s harmony!",
  
  "(chorus)",
  "The sun brings light, the sun brings heat,",
  "It warms the Earth beneath our feet.",
  "Some light reflects, some light’s absorbed,",
  "It powers the Earth, a life-giving force!",
  "The sun brings light, the sun brings heat,",
  "It warms the Earth beneath our feet.",
  "Some light reflects, some light’s absorbed,",
  "It powers the Earth, a life-giving force!",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      
    ],
  },
  
  {
    title: "See Through", standardNumber: "1-PS4-3", slug: "seethrough",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseethrough2025video.mp4?alt=media&token=9fd26a05-07dc-4e05-b5b0-0f9f997444e6 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseethrough2025song.mp3?alt=media&token=369a78c4-6932-4cc9-b40a-df1fe1fc7a35 ",
    lyrics: ["(chorus)",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  
  "(verse)",
  "Transparent means that light goes right through it.",
  "Translucent means that some light can go through it.",
  "Opaque means that no light can go through it.",
  "These are some properties of materials, some properties of materials.",
  "Transparent objects are clear and through them, you can see.",
  "Translucent materials, you can’t see through as clearly.",
  "Opaque materials are opposite, you can’t see through them at all.",
  "These are some properties of materials, some properties of materials.",
  
  "(chorus)",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  {
      title: "", standardNumber: "1-PS4-4", slug: "",
      gameType: "multipleChoice", titleImage: "", // Motion image URL
      description: "",
      video: "",
      music: "",
      lyrics: [
        
      ],
    },
  
  {
    title: "Adaptation", standardNumber: "1-LS1-1", slug: "adaptation",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptation2025video.mp4?alt=media&token=38306b56-b3b8-4d35-9d62-460a899023b4 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptation2025song.mp3?alt=media&token=dc122dec-b0b5-4656-82c2-8e1c2297489b ",
    lyrics: ["(Chorus)",
  "What is adaptation? The way plants and animals learn to survive.",
  "What is adaptation? How they live in their habitat or environment.",
  "We adapt, we adapt,",
  "To our habitat, to our habitat.",
  
  "(Verse 1)",
  "There are some places on Earth that’s very cold or very hot,",
  "And still plants and animals live there, they’ve adapted to being there.",
  "Some places on Earth have lots of water or lots of rocks,",
  "And still plants and animals live there, they’ve adapted to being there.",
  "Let’s take a place that doesn’t have much water.",
  "Plants and animals both know how to conserve water, store that water.",
  "Let’s take a place with high temperatures.",
  "Plants move their leaves to minimize surface area hit by the sun.",
  "In a place with high temperatures,",
  "They both reduce heat output and animals use the shade to avoid the sun.",
  
  "(Chorus)",
  "What is adaptation? The way plants and animals learn to survive.",
  "What is adaptation? How they live in their habitat or environment.",
  "We adapt, we adapt,",
  "To our habitat, to our habitat.",
  
  "(Verse 2)",
  "Some animals camouflage, change their color or pattern to blend in.",
  "Some animals’ mimicry, change their whole look to look like something different.",
  "Some plants have needles, to cause pain feelings in animals that touch it.",
  "Some plants are poison, to harm an enemy that tries to eat it.",
  
  "(Chorus)",
  "What is adaptation? The way plants and animals learn to survive.",
  "What is adaptation? How they live in their habitat or environment.",
  "We adapt, we adapt,",
  "To our habitat, to our habitat.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  
  {
    title: "Adaptive Characteristics", standardNumber: "1-LS1-1", slug: "adaptivecharacteristics",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptivecharacteristics2025video.mp4?alt=media&token=8bef488a-f405-4403-bf1d-b2befa2d032d ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptivecharacteristics2025song.mp3?alt=media&token=07c0340b-fe8d-4ae7-8c5b-b4355a19bacd ",
    lyrics: ["(chorus)",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  
  "(verse)",
  "Some animals have webbed feet just like an otter.",
  "They can search for food in the water, it makes them swim better.",
  "Some animals have sharp claws, like meat eaters,",
  "and they use those claws for killing their prey.",
  "Some use them for digging for food or shelter, hay.",
  "Some animals have large beaks, it helps some animals eat.",
  "Some animals have large teeth, it helps the animals eat.",
  "Some animals have large beaks, it helps some animals eat.",
  
  "(chorus)",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  
  "(verse)",
  "Some animals have webbed feet just like an otter.",
  "They can search for food in the water, it makes them swim better.",
  "Some animals have sharp claws, like meat eaters,",
  "and they use those claws for killing their prey.",
  "Some use them for digging for food or shelter, hay.",
  "Some animals have large beaks, it helps some animals eat.",
  "Some animals have large teeth, it helps the animals eat.",
  "Some animals have large beaks, it helps some animals eat.",
  
  "(chorus)",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  
  {
    title: "Adapt to Survive", standardNumber: "1-LS1-1", slug: "adapttosurvive",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadapttosurvivie2025video.mp4?alt=media&token=d7a55d38-6f01-48b5-842d-37634069c361 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadapttosurvive2025song.mp3?alt=media&token=118906ed-f2bd-4a02-ae36-c519e8166ed8 ",
    lyrics: ["(Chorus)",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, it’s nature’s way.",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "Some plants and animals have special traits,",
  "To adapt to survive, adapt to survive.",
  
  "(Verse 1)",
  "A plant with thorns keeps danger away,",
  "While other plants get eaten, every day.",
  "Camouflage helps an animal hide,",
  "Safe from danger, it stays alive.",
  "Spots or stripes can blend right in,",
  "Hiding from predators, so they can win.",
  "In a changing world, traits play a role,",
  "Helping animals reach their goal.",
  
  "(Chorus)",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, it’s nature’s way.",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "Some plants and animals have special traits,",
  "To adapt to survive, adapt to survive.",
  
  "(Verse 2)",
  "Cause and effect, it’s easy to see,",
  "Traits help some live and set them free.",
  "Reproducing stronger, they’ll stay alive,",
  "Passing on traits, so life will thrive.",
  "So watch the world, it’s clear and true,",
  "Survival depends on what they do.",
  "Traits that help, they carry on,",
  "The cycle of life will keep moving strong!",
  
  "(Chorus)",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, it’s nature’s way.",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "Some plants and animals have special traits,",
  "To adapt to survive, adapt to survive.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  
  {
    title: "Animal Life Cycles", standardNumber: "1-LS1-2", slug: "animallifecycles",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimallifecycle2025song%20.mp3?alt=media&token=666e6c14-f00a-4379-95cc-3047adb2ac18 ",
    lyrics: ["(Chorus)",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  
  "(Verse)",
  "Now, all animal life cycles are the same in some ways.",
  "We’re all born, we develop, we reproduce, then the cycle starts over again.",
  "Humans start reproducing from an egg inside a mother's body,",
  "For 9 months then they’re born, learning for 3 years as babies.",
  "Then we grow into children, taller, smarter, more independent.",
  "Around the ages 13 to 18, we’re teenagers, adolescents.",
  "After that, we become adults until we are old and grey.",
  "Start a family, when we reproduce the life cycle starts over again.",
  
  "(Chorus)",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  
  {
    title: "Inherited", standardNumber: "1-LS3-1", slug: "inherited",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Finherited2025video.mp4?alt=media&token=91e47b15-2c11-480d-87d0-ce23342bd813 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finherited2025song.mp3?alt=media&token=0618f70d-a9ce-4a81-b04c-39e9dcaa6ef6 ",
    lyrics: ["(Chorus)",
  "When animals are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  "When plants are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  
  "(Verse)",
  "Now, animals can inherit some features from their parents,",
  "Like the color of their hair or the color of their eyes.",
  "Animals can inherit some features from their parents,",
  "Like the complexion of their skin or even their height.",
  "Plants too, can inherit from their parents",
  "Their color, their size, and shape.",
  "When genes are passed down from your parents,",
  "Different features you take.",
  
  "(Chorus)",
  "When animals are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  "When plants are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  
  "(Verse)",
  "Now, animals can inherit some features from their parents,",
  "Like the color of their hair or the color of their eyes.",
  "Animals can inherit some features from their parents,",
  "Like the complexion of their skin or even their height.",
  "Plants too, can inherit from their parents",
  "Their color, their size, and shape.",
  "When genes are passed down from your parents,",
  "Different features you take.",
  
  "(Chorus)",
  "When animals are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  "When plants are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  
  {
    title: "Offspring", standardNumber: "1-LS3-1", slug: "offspring",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Foffspring2025song.mp3?alt=media&token=cd9d4279-1bec-4d21-9904-e09aa0beb4c6 ",
    lyrics: ["(chorus)",
  "Offspring are alike, but not the same,",
  "Different colors, shapes, or names!",
  "From parents, they come, with traits to share,",
  "But each one is special, beyond compare!",
  
  "(verse)",
  "Kittens from a mama cat, fluffy and sweet,",
  "Some are orange, some black, a mix that’s neat.",
  "Puppies from the same mom can all look new,",
  "With spots or stripes, and colors too!",
  "Baby birds in a nest, they chirp and sing,",
  "Some have feathers with a shiny wing.",
  "Plants grow seeds, they sprout and bloom,",
  "Each flower’s color can fill the room!",
  
  "(chorus)",
  "Offspring are alike, but not the same,",
  "Different colors, shapes, or names!",
  "From parents, they come, with traits to share,",
  "But each one is special, beyond compare!",
  
  "(verse)",
  "Parents pass traits, like eyes or hair,",
  "But changes happen here and there.",
  "Variation makes nature bright,",
  "No two are the same, it’s a wonderful sight!",
  "So look around and you will see,",
  "Offspring are full of variety!",
  "From animals to plants, they’re all unique,",
  "Nature’s creations are quite the treat!",
  "(chorus)",
  "Offspring are alike, but not the same,",
  "Different colors, shapes, or names!",
  "From parents, they come, with traits to share,",
  "But each one is special, beyond compare!",
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  { 
    title: "Night & Day", standardNumber: "1-ESS1-1", slug: "nightandday",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnightandday2025video.mp4?alt=media&token=0df32858-e1bd-4e92-9c18-dc595d6b52a9 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnightandday2025video.mp4?alt=media&token=0df32858-e1bd-4e92-9c18-dc595d6b52a9 ",
    lyrics: ["(Intro)",
  "Day and night, day and night, day and night, day and night.",
  "Night and day, night and day, night and day, night and day.",
  
  "(Chorus)",
  "In the daytime, you see the light and it’s dark at night,",
  "Yeah, it’s dark at night,",
  "Yeah, yeah, it’s dark at night.",
  "In the daytime, you see the light and it’s dark at night,",
  "Yeah, it’s dark at night,",
  "Yeah, yeah, it’s dark at night.",
  
  "(Verse)",
  "Because the Earth spins around,",
  "And makes a full turn in 24 hours,",
  "The sun only lights up half of the Earth at a time.",
  "The side with the light is daytime.",
  "The other side is dark—that’s nighttime.",
  "As the Earth spins, daytime shifts to the other side.",
  "As the Earth spins, nighttime shifts to the other side.",
  
  "(Chorus)",
  "In the daytime, you see the light and it’s dark at night,",
  "Yeah, it’s dark at night,",
  "Yeah, yeah, it’s dark at night.",
  "In the daytime, you see the light and it’s dark at night,",
  "Yeah, it’s dark at night,",
  "Yeah, yeah, it’s dark at night.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  {
    title: "The Moon & The Sky", standardNumber: "1-ESS1-1", slug: "themoonandthesky",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthemoonandthesky2025video.mp4?alt=media&token=4d813ee9-9d5c-4f61-a049-c5c881de9dbf ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthemoonandthesky2025song.wav?alt=media&token=5a3b8f24-5155-4a0e-9e22-1f7c3f4519e1 ",
    lyrics: ["(Chorus)",
  "The moon and the sky, what do we see?",
  "The sun, the stars, and the moon for you and me!",
  "Daytime and nighttime, changes all the way,",
  "The moon is so special, it shines both night and day!",
  
  "(Verse 1)",
  "The sun is bright, it lights the day,",
  "The moon’s a little different, in its own way.",
  "Sometimes at night, sometimes in the day,",
  "The moon is up there, shining far away!",
  "The stars come out when the sky is dark,",
  "Twinkling brightly, like a glowing spark.",
  "The moon has patterns, it changes its face,",
  "A crescent, a circle, it’s a magical place!",
  
  "(Chorus)",
  "The moon and the sky, what do we see?",
  "The sun, the stars, and the moon for you and me!",
  "Daytime and nighttime, changes all the way,",
  "The moon is so special, it shines both night and day!",
  
  "(Verse 2)",
  "From new moon to full, it grows so bright,",
  "Then back to a crescent, fading from sight.",
  "Day by day, it’s a wonderful show,",
  "The moon’s always changing, just so you know!",
  "So look at the sky, both day and night,",
  "The sun, moon, and stars are such a delight.",
  "Patterns to watch, the moon leads the way,",
  "A part of our sky every single day!",
  
  "(Chorus)",
  "The moon and the sky, what do we see?",
  "The sun, the stars, and the moon for you and me!",
  "Daytime and nighttime, changes all the way,",
  "The moon is so special, it shines both night and day!",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },
  {
    title: "Seasons", standardNumber: "1-ESS1-2", slug: "seasons",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseasons2025video.mp4?alt=media&token=dd682414-ff8a-4acb-8877-5a488cd7a912 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseasons2025song.mp3?alt=media&token=04a34ce0-7b3c-4e70-8564-cc5ac75c2bfc ",
    lyrics: ["(chorus)",
  "There is something we have to get clear now,",
  "there are four seasons in every year now.",
  "Do you know the reasons for the seasons? Check this,",
  "seasons come because of the tilt of the Earth's axis.",
  
  "(verse)",
  "We spring ahead in the Spring, then comes the Summer.",
  "Watch the leaves change color, we fall back in Autumn.",
  "Then comes the Winter, which is the coldest season.",
  "The Earth spins on an axis that is tilted, is the reason why this happens.",
  
  "(chorus)",
  "There is something we have to get clear now,",
  "there are four seasons in every year now.",
  "Do you know the reasons for the seasons? Check this,",
  "seasons come because of the tilt of the Earth's axis.",
  
  "(bridge)",
  "Summer, Winter, Spring, Fall.",
  "Summer, Winter, Spring, Fall.",
  "Summer, Winter, Spring, Fall.",
  "Summer, Winter, Spring, Fall.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
  
    ],
  },

];
export default topics;
